import React from "react";
import { useErrorModal } from "../contexts/ErrorModalContext";

const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9000,
};

const contentStyle = {
  background: "#191725",
  color: "#fff",
  borderRadius: "12px",
  padding: "32px 24px 24px 24px",
  minWidth: "320px",
  maxWidth: "90vw",
  boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
  textAlign: "center",
  position: "relative",
};

const closeBtnStyle = {
  position: "absolute",
  top: 12,
  right: 16,
  background: "none",
  border: "none",
  color: "#b68cff",
  fontSize: 22,
  cursor: "pointer",
};

export default function ErrorModal() {
  const { open, message, closeError } = useErrorModal();
  if (!open) return null;
  return (
    <div style={modalStyle} onClick={closeError}>
      <div style={contentStyle} onClick={(e) => e.stopPropagation()}>
        <button style={closeBtnStyle} onClick={closeError} aria-label="Close">
          &times;
        </button>
        <h3 style={{ color: "#b68cff", marginBottom: 16 }}>Error</h3>
        <div style={{ marginBottom: 18, maxWidth: "40vw" }}>{message}</div>

        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <button
            onClick={closeError}
            style={{
              background: "#b68cff",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "8px 24px",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: 16,
            }}
          >
            Upgrade Plan
          </button>
        </div>
      </div>
    </div>
  );
}
